export const normalizeHandle = (handle?: string | null) => {
  if (!handle) return '';
  return handle.replace(/^@+/, '').trim();
};

export const formatHandle = (handle?: string | null) => {
  const normalized = normalizeHandle(handle);
  return normalized ? `@${normalized}` : '';
};

export const getProfilePath = (authorId: string, authorHandle?: string | null): string => {
  const handle = normalizeHandle(authorHandle);
  if (handle) {
    return `/profile/@${handle}`;
  }
  return `/profile/${authorId}`;
};
